import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';

import FooterPublic from '~/components/organisms/FooterPublic/FooterPublic';
import HeaderPublic from '~/components/organisms/HeaderPublic/HeaderPublic';
import Accordion from '~/components/ui/Accordion/Accordion';
import { Text } from '~/components/ui/text';
import { getIsDesktop } from '~/store/reducers/app/selectors';

export default function FAQ() {
  const { t } = useTranslation();

  const isDesktop = useSelector(getIsDesktop);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <HeaderPublic />
      <Box margin="0 auto" maxWidth="1366px" padding={isDesktop ? '16px 83px 60px' : '16px 16px 60px'}>
        <Text variant={isDesktop ? 'h1.5' : 'h2'} sx={{ margin: '40px 0', textAlign: 'center' }}>
          {t('landing:faqBlock.title')}
        </Text>
        {Array(13)
          .fill(undefined)
          .map((_, index) => {
            return <Accordion key={index} summary={t(`faq:title${index}`)} details={t(t(`faq:subTitle${index}`))} />;
          })}
      </Box>
      <FooterPublic />
    </>
  );
}
